import React from 'react';
import { Tooltip } from '@material-ui/core';
import { PlayerInfoProps } from '@screens/players/types/player.info.props';
import { vipDescriptions } from '@data/vip.descriptions';
import { InfoArea, InfoAreaTitle } from '@screens/players/player.details.tabs/player.info.styles';
import { StatsContainer } from '@screens/players/stats.container';
import { StatRow } from '@screens/players/stat.display';
import { InlineIcon } from '@styles/common';
import { StatIcon } from '@screens/players/stat.icon';
import { getVipDate } from '@domain/utils/vip.info.utils';
import { formatStringDate } from '@domain/utils/format.utils';

export const VipCompleteInfo = ({ player }: PlayerInfoProps) => {
  const { vipInfo } = player;
  if (!vipInfo) return null;

  const { stars } = vipInfo;
  const description = vipDescriptions[stars];

  return (
    <InfoArea>
      <InfoAreaTitle>VIP Info</InfoAreaTitle>
      <StatsContainer outlined column expandHeight>
        <StatRow label='Level'>
          {stars <= 0 && (
            <Tooltip title='Not VIP'>
              <InlineIcon>remove</InlineIcon>
            </Tooltip>
          )}
          {stars > 0 && (
            <>
              <StatIcon icon={`gem${stars}`} alt={description} /> {description} (#{stars}) <strong>since</strong> {getVipDate(vipInfo) || '-'}
            </>
          )}
        </StatRow>
        <StatRow label='Expire Date'>{formatStringDate(vipInfo.expireDate)}</StatRow>
        <StatRow label='Available Rocklets'>{vipInfo.consumableRocklets}</StatRow>
        <StatRow label='Level Rocklets'>{vipInfo.levelRocklets}</StatRow>
        <StatRow label='Maintenance Rocklets'>{vipInfo.maintenanceRocklets}</StatRow>
      </StatsContainer>
    </InfoArea>
  );
};
